import { render, staticRenderFns } from "./MoveToResolvedModal.vue?vue&type=template&id=bf821da2&scoped=true"
import script from "./MoveToResolvedModal.vue?vue&type=script&lang=js"
export * from "./MoveToResolvedModal.vue?vue&type=script&lang=js"
import style0 from "./MoveToResolvedModal.vue?vue&type=style&index=0&id=bf821da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf821da2",
  null
  
)

export default component.exports